<div class="blog-wrap">
  <div class="row">
    <div class="col-12">
      <h1 class="heading-22">News</h1>
      <p class="body-txt-16 mb-3">
        View and manage the news articles for public website.
      </p>
    </div>
  </div>

  <div class="table-search-wrap mb-1 mb-md-4 pb-2">
    <div class="d-none d-md-block">
      <div class="row for-desktop-filters">
        <div class="col-9">
          <div class="row">
            <div class="col-6 pr-0">
              <div class="form-group">
                <div class="custom-search-with-icon filter-with-clear">
                  <input
                    class="form-control"
                    type="search"
                    placeholder="Title or Content or Author"
                    [formControl]="searchControl"
                    [maxlength]="searchMaxLength"
                  />
                  <span
                    class="filter-icon"
                    role="button"
                    (click)="resetSearch()"
                    *ngIf="searchControl.value != null"
                  >
                    <img
                      src="../assets/images/cross.svg"
                      title="filter-search-icon"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 text-right">
          <button
            class="btn btn-colored"
            type="button"
            [routerLink]="['../add']"
          >
            + Add News
          </button>
        </div>
      </div>
    </div>

    <div class="for-mobile-filters d-block d-md-none">
      <div class="row mobile-filters-wrap" [class.activeFilter]="classToggled">
        <div class="for-search">
          <div class="form-group m-0">
            <div class="custom-search-with-icon mob-search-input">
              <input
                class="form-control"
                type="text"
                placeholder="Name or email or Paddle Number"
                [formControl]="searchControl"
                [maxlength]="searchMaxLength"
              />
              <div
                class="for-open-search"
                role="button"
                (click)="classToggled = true"
              ></div>
              <div class="for-input-close">
                <span
                  class="icon"
                  role="button"
                  (click)="resetSearch()"
                  *ngIf="searchControl.value != null"
                >
                  <img
                    src="../assets/images/cross.svg"
                    title="mobile-search-icon"
                  />
                </span>
                <span class="text" role="button" (click)="classToggled = false"
                  >Cancel</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="for-btns text-right">
          <button
            class="btn btn-colored"
            type="button"
            [routerLink]="['../add']"
          >
            + Add News
          </button>
        </div>
      </div>
    </div>
  </div>

  <section>
    <div class="empty-state-container" *ngIf="totalBlog <= 0; else showTable">
      <div class="empty-state-content">
        <img src="../../../../assets/images/empty-state-icon.svg" />
        <h3 class="_heading">No results found</h3>
      </div>
    </div>

    <ng-template #showTable>
      <app-paginator
        [paginationId]="'server'"
        [currentPage]="pageNumber"
        [pageSize]="pageSize"
        (page)="onPageChange($event)"
        *ngIf="totalBlog > pageSize"
      >
      </app-paginator>

      <div class="data-table-wrap w-100">
        <table
          mat-table
          [dataSource]="
            blogData
              | paginate
                : {
                    id: 'server',
                    itemsPerPage: pageSize,
                    currentPage: pageNumber,
                    totalItems: totalBlog
                  }
          "
          class="mat-elevation-z8 custom-data-table blog-table-width"
        >
          <ng-container matColumnDef="draftTitle">
            <th
              class="column-1 listing-header-name"
              mat-header-cell
              *matHeaderCellDef
            >
              <h3>News Title</h3>
            </th>
            <td
              class="column-1 listing-data-entry name"
              data-column="Blog Title"
              mat-cell
              *matCellDef="let element"
            >
              <span>{{
                (element.draftTitle ? element.draftTitle : element.title)
                  | titlecase
              }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdOn">
            <th
              class="column-2 listing-header-name"
              mat-header-cell
              *matHeaderCellDef
            >
              <h3>Last Updated</h3>
            </th>
            <td
              class="column-2 listing-data-entry name"
              data-column="Last Updated"
              mat-cell
              *matCellDef="let element"
            >
              <span>{{
                element.updatedOn || element.createdOn | toLocalDateTime
              }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="blogName">
            <th
              class="column-3 listing-header-name"
              mat-header-cell
              *matHeaderCellDef
            >
              <h3>Status</h3>
            </th>
            <td
              class="column-3 listing-data-entry actions"
              data-column="Status"
              mat-cell
              *matCellDef="let element"
            >
              <span>
                {{ element.draftTitle ? "Drafted" : "Published" }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              class="column-4 listing-header-name"
              mat-header-cell
              *matHeaderCellDef
            ></th>
            <td
              class="column-4 listing-data-entry name"
              mat-cell
              *matCellDef="let element"
            >
              <div class="for-icons ml-auto">
                <a
                  class="hover-icon edit-icon mr-2 custom-tooltip custom-tooltip2"
                  #tooltip="matTooltip"
                  matTooltip="Edit"
                  matTooltipClass="custom-tooltip-icon"
                  [matTooltipPosition]="'above'"
                  [routerLink]="['../edit', element.id]"
                ></a>
                <button
                  type="button"
                  class="hover-icon delete-icon custom-tooltip custom-tooltip2"
                  #tooltip="matTooltip"
                  matTooltip="Delete"
                  matTooltipClass="custom-tooltip-icon"
                  [matTooltipPosition]="'above'"
                  role="button"
                  (click)="openModal(deleteModal, element)"
                ></button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <app-paginator
        [paginationId]="'server'"
        [currentPage]="pageNumber"
        [pageSize]="pageSize"
        (page)="onPageChange($event)"
        *ngIf="totalBlog > pageSize"
      >
      </app-paginator>
    </ng-template>
  </section>
</div>

<ng-template #deleteModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button
      type="button"
      class="close pull-right p-0 m-0"
      aria-label="Close"
      role="button"
      (click)="modalRef.hide()"
    >
      <img src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body">
    <div class="delete-data">
      <img src="../assets/images/delete-icon.svg" class="delete-icon" />
      <h1 class="modal-inner-hdg mt-3 mb-0">Delete News</h1>
      <p class="des">
        Do you really want to delete
        <br />
        <span class="for-highlight">
          {{ blogName }}
        </span>
        news ?
      </p>
      <div class="delete-btns">
        <button
          class="btn btn-text mr-3"
          role="button"
          (click)="modalRef.hide()"
        >
          Cancel
        </button>

        <button
          class="btn btn-colored"
          role="button"
          (click)="onDelete(blogId)"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>
